export const verifyStatusData = [
  { content: '全部', key: -1, value: -1 },
  { content: '待审核', key: 0, value: 0 },
  { content: '已通过', key: 1, value: 1 },
  { content: '已拒绝', key: 2, value: 2 },
];
export const auditTypeList = [
  { content: '全部', key: 0, value: 0 },
  { content: '资质信息', key: 1, value: 1 },
  { content: '餐厅信息', key: 2, value: 2 },
];
export const beijingLevels = [
  { label: 'A★★★', value: 'beijing_1' },
  { label: 'A★★', value: 'beijing_2' },
  { label: 'B★★★', value: 'beijing_3' },
  { label: 'A★', value: 'beijing_4' },
  { label: 'B★★', value: 'beijing_5' },
  { label: 'C★★★', value: 'beijing_6' },
  { label: 'C★★', value: 'beijing_7' },
  { label: 'B★', value: 'beijing_8' },
  { label: 'C★', value: 'beijing_9' },
];
export const auditTypeStatusList = {
  QULIFICATION: 1,
  RESTAURANT: 2,
};
export const ResVerifyStatusData = [
  { content: '全部', key: -1, value: -1 },
  // { content: '未提交', key: 0, value: 0 },
  { content: '待审核', key: 1, value: 1 },
  { content: '已通过', key: 2, value: 2 },
  { content: '已拒绝', key: 3, value: 3 },
];
export const ResVerifyStatusType = {
  0: '未提交',
  1: '待审核',
  2: '已通过',
  3: '已拒绝',
  4: '免信息',
  5: '取消免信息',
};
export const rejectReasons = [
  { label: '营业执照注册号或统一社会信用代码错误', value: 1 },
  { label: '复印件未盖章', value: 2 },
  { label: '营业执照过期', value: 3 },
  { label: '食品安全许可证过期', value: 4 },
  { label: '营业执照经营范围与申请内容不符', value: 5 },
  { label: '营收项目信息填写不全', value: 7 },
  { label: '其他', value: 6 },
];

export const verifyStatusList = ['待审核', '已通过', '已拒绝'];
export const certificatesTypeList = ['', '食品经营许可证', '食品生产许可证', '三小类许可证'];

export const foodSafeRefusedData = [
  { value: 0, content: '无' },
  { value: 1, content: '资质证件问题' },
  { value: 2, content: '信息填写问题' },
  { value: 3, content: '照片上传问题' },
  { value: 4, content: '其他问题' },
];
export const doorRefusedData = [
  { value: 0, content: '无' },
  { value: 1, content: '环境问题' },
  { value: 2, content: '信息填写问题' },
  { value: 3, content: '照片上传问题' },
  { value: 4, content: '其他问题' },
];
export const anteroomRefusedData = [
  { value: 0, content: '无' },
  { value: 1, content: '食安问题' },
  { value: 2, content: '环境问题' },
  { value: 3, content: '信息填写问题' },
  { value: 4, content: '照片上传问题' },
  { value: 5, content: '其他问题' },
];
export const kitchenRefusedData = [
  { value: 0, content: '无' },
  { value: 1, content: '食安问题' },
  { value: 2, content: '环境问题' },
  { value: 3, content: '信息填写问题' },
  { value: 4, content: '照片上传问题' },
  { value: 5, content: '其他问题' },
];

export const RejectPositionItem = {
  HEALTH: 1, // 健康证
  DOOR: 2, // 门头
  OFFICE: 3, // 前厅
  KITCHEN: 4, // 厨房
};

export const ShopTypeList = [
  { content: '全部', key: -1, value: -1 },
  { content: '直营店', key: 1, value: 1 },
  { content: '加盟店', key: 2, value: 2 },
  { content: '未设置', key: 0, value: 0 },
];

export const verifyType = [
  { content: '全部', key: -1, value: -1 },
  { content: '首次上传', key: 1, value: 1 },
  { content: '资质更新', key: 2, value: 2 },
];

export const merchantTypeOptions = [
  { content: '全部', key: '', value: '' },
  { content: '餐饮门店', key: 0, value: 0 },
  { content: '福利商城门店', key: 1, value: 1 },
];

export enum verifyTypeStatus {
  '首次上传' = 1,
  '资质更新' = 2,
}
export enum merchantTypeStatus {
  '餐饮门店' = 0,
  '福利商城门店' = 1,
}
